export default "__VITE_ASSET__a$V_gHrj__"